import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-ok",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class OkButtonComponent extends EceButtonComponent {
  icon = "check";
}
